module.exports = __webpack_public_path__ + "officialStatic/img/money1.2f2fff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/money1.png
// module id = IDky
// module chunks = 0